import { defineStore } from "pinia";
import magApi from "@/api/MagApi";

export const useMagStore = defineStore("mag", {
  state: () => {
    return {
      categories: [],
      category: {},
      posts: {},
      post_header: {},
      post: {},
      genres: [],
      genres_posts: {},
      row_items: {},
      rows: {},
      row_item: {},
      filters: {
        page_size: 18,
        mine: false,
        processing_status: 2,
        page: 1
      }
    };
  },
  getters: {},
  actions: {
    async getCategories() {
      this.categories = await magApi.getCategories();
    },
    async getCategory(slug) {
      this.category = this.categories?.results?.find(
        item => item?.slug === slug.categoryName
      );
    },
    async getPosts() {
      this.posts = await magApi.getPosts();
    },
    async getPost(id) {
      this.post = await magApi.getPost(id);
    },
    async clearPost() {
      this.post = {};
    },
    async getPostFilter(params) {
      let provisionalPost = await magApi.getPostFilter(params);
      let allPosts = { ...provisionalPost };
      if (params.category_slug) {
        params.extra_category_slug = params.category_slug;
        delete params.category_slug;
        let extraCategoryPosts = await magApi.getPostFilter(params);
        provisionalPost.magposts = provisionalPost.magposts.concat(
          extraCategoryPosts.magposts
        );
        provisionalPost.magposts = provisionalPost.magposts.sort(
          (a, b) => new Date(b.published_date) - new Date(a.published_date)
        );
      }
      this.post_header = allPosts?.magposts.find(post => post.is_header);
      this.posts = provisionalPost;
      this.posts.magposts = provisionalPost?.magposts.filter(data => {
        return data?.id !== this.post_header?.id;
      });
    },
    async getMultimedias() {
      await magApi.getMultimedias();
    },
    async getMultimedia() {
      await magApi.getMultimedia();
    },
    async getTags() {
      await magApi.getTags();
    },
    async getTag(id) {
      await magApi.getTag(id);
    },
    async getGenres() {
      this.genres = await magApi.getGenres();
    },
    async getMagRowItems() {
      this.row_items = await magApi.getMagRowItems();
    },
    async getMagRowItemsParam(param) {
      try {
        this.row_item = await magApi.getMagRowItemsParam(param);
        this.row_item.magrowitems = this.row_item?.magrowitems.sort(
          (a, b) => a.numeric_order - b.numeric_order
        );
      } catch (err) {
        console.log(err);
      }
    },
    async getGenrePosts(genre) {
      const params = { genres_id: genre.id };
      this.genres_posts[`${genre.id}`] = (
        await magApi.getPostFilter(params)
      ).magposts;
    },
    removeGenrePosts(genre) {
      delete this.genres_posts[`${genre.id}`];
    }
  }
});
